module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rachel Lee\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rachel Lee was hooked on writing by the age of twelve and has lived all over the United States. This New York Times bestselling author now resides in Florida and writes full-time. Research is one of her favorite things."), _c('Br', [_c('Br', [_vm._v("Rachel loves her pets nearly as much as her four children. She has had both dogs and cats and is currently enjoying the antics of Jazz, her bloodhound. She also calls him her \"Gentle Giant.\""), _c('Br', [_c('Br', [_vm._v(" "), _c('Br', [_c('Br', [_vm._v(" "), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ailvwW/tc-custom/9781488046070.jpg?1740827569509",
      "alt": "This image is the cover for the book Murdered in Conard County, Conard County: The Next Generation"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murdered in Conard County, Conard County: The Next Generation\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Friends become lovers when two military veterans turned park rangers investigate murder in this romantic suspense from a "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("After a shot rings out in the night, park ranger Blaire Afton knows her hard-won serenity is in jeopardy. But when she’s faced with a murder with no motive and no clues, US forest ranger Gus Maddox agrees with her suspicion that this is no random crime. With their shared military past, Blaire and Gus become close. But will their need for each other hinder their quest for justice?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0